import { Component, EventEmitter, Input, Output } from '@angular/core';
import { makeDateRangeText } from 'core/date/date-range-text-helper';
import { cloneDeep } from 'lodash-es';
import { RangeOrRelativeDateInputModel } from 'shared/components/range-or-relative-date-input/range-or-relative-date-input.component';

export interface DateRangeAndUsersQueryLinkEvent {
  dateRange: RangeOrRelativeDateInputModel;
  userIds: string[];
}

@Component({
  selector: 'app-date-range-and-users-query-link',
  templateUrl: './date-range-and-users-query-link.component.html',
  styleUrls: ['./date-range-and-users-query-link.component.scss']
})

export class DateRangeAndUsersQueryLinkComponent {
  @Input() dateRange: RangeOrRelativeDateInputModel;
  @Input() userIds: string[];

  @Output() itemClicked: EventEmitter<DateRangeAndUsersQueryLinkEvent> = new EventEmitter<DateRangeAndUsersQueryLinkEvent>();


  buttonClicked() {
    this.itemClicked.emit(
      cloneDeep({
        dateRange: this.dateRange,
        userIds: this.userIds
      }));
  }

  getUserText() {
    const safeUsers = this.userIds || [];
    if (safeUsers.length === 0) { return 'any user'; }
    if (safeUsers.length === 1) { return '1 user'; }
    return `${safeUsers.length} Users`;
  }


  getTimeText() {
    if (this.dateRange == null) { return 'anytime'; }
    // Check if all properties of dateRange are null
    if (Object.values(this.dateRange).every((x) => x == null)) { return 'anytime'; }

    return makeDateRangeText(this.dateRange);
  }
}
